var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSymbolIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FF627D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 18.5C11.8253 18.5 8.42529 21.3 8.42529 24.75C8.42529 24.9833 8.60863 25.1667 8.84196 25.1667H23.1586C23.392 25.1667 23.5753 24.9833 23.5753 24.75C23.5753 21.3 20.1753 18.5 16.0003 18.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0918 9.05008C18.3418 8.20008 17.2252 7.66675 16.0002 7.66675C14.8335 7.66675 13.7668 8.14175 13.0085 8.92508C12.2835 9.67508 11.8335 10.7084 11.8335 11.8334C11.8335 12.6167 12.0502 13.3501 12.4418 13.9751C12.6502 14.3334 12.9168 14.6584 13.2335 14.9251C13.9585 15.5917 14.9252 16.0001 16.0002 16.0001C17.5252 16.0001 18.8418 15.1834 19.5668 13.9751C19.7835 13.6167 19.9502 13.2167 20.0418 12.8001C20.1252 12.4917 20.1668 12.1667 20.1668 11.8334C20.1668 10.7667 19.7585 9.79175 19.0918 9.05008ZM17.5585 12.6001H16.7835V13.4084C16.7835 13.8417 16.4335 14.1917 16.0002 14.1917C15.5668 14.1917 15.2168 13.8417 15.2168 13.4084V12.6001H14.4418C14.0085 12.6001 13.6585 12.2501 13.6585 11.8167C13.6585 11.3834 14.0085 11.0334 14.4418 11.0334H15.2168V10.2917C15.2168 9.85841 15.5668 9.50841 16.0002 9.50841C16.4335 9.50841 16.7835 9.85841 16.7835 10.2917V11.0334H17.5585C17.9918 11.0334 18.3418 11.3834 18.3418 11.8167C18.3418 12.2501 17.9918 12.6001 17.5585 12.6001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSymbolIcon);
export default __webpack_public_path__ + "static/media/user-symbol-icon.6cd5f69a152f340afa6b8df5779ce5ec.svg";
export { ForwardRef as ReactComponent };